var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-date-field"},[_c('VueCtkDateTimePicker',_vm._g(_vm._b({staticClass:"custom-date-time-picker custom-date-time-picker--range",attrs:{"value":_vm.value,"color":_vm.$style.accent,"button-color":_vm.$style.accent}},'VueCtkDateTimePicker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }